<script>
    import { createEventDispatcher, onMount, beforeUpdate } from 'svelte';
    import { theme } from '../stores/themeStore';
    import { userRole, isReadOnly } from '../stores/sessionStore';
  
    export let showConfirmation = false;
    export let message = '';
    export let confirmPhrase = 'delete';
    export let disableConfirm = false;
    export let disableMessage = '';
  
    let inputPhrase = '';
    const dispatch = createEventDispatcher();
  
    $: if (showConfirmation) {
      inputPhrase = '';
    }

    function close() {
      dispatch('close');
    }
  
    function confirm() {
    if (inputPhrase === confirmPhrase) {
      dispatch('confirm');
      close();
    }
  }
  </script>
  
  {#if showConfirmation}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div class="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm">
        <div class="modal-overlay absolute inset-0 bg-slate-800 opacity-75" on:click={close}></div>
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div class="bg-white dark:bg-gray-900 p-4 rounded-lg shadow-lg w-full max-w-sm relative z-60" on:click|stopPropagation>
        <header class="flex justify-between items-start mb-4 text-gray-900 dark:text-gray-100">
          <h2>Confirmation</h2>
        </header>
        <div class="mb-4 text-gray-900 dark:text-gray-100">
          <p class="pb-2 text-gray-500 dark:text-gray-400">{message}</p>
          <p class="text-xs pb-1 text-gray-500 dark:text-gray-400">Please type "{confirmPhrase}" to confirm.</p>
          <input 
            type="text" 
            bind:value={inputPhrase} 
            class="border p-1 w-full rounded dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
            disabled={disableConfirm || isReadOnly()}
            class:opacity-50={disableConfirm || isReadOnly()}
            class:cursor-not-allowed={disableConfirm || isReadOnly()}
          />
          {#if disableMessage}
            <p class="mt-2 text-xs text-red-500 dark:text-red-400">{disableMessage}</p>
          {/if}
        </div>
        <div class="flex justify-end space-x-2 pt-2">
          <button on:click="{close}" class="bg-gray-500 text-white py-1 px-2 rounded hover:bg-gray-700">Cancel</button>
          <button 
            on:click="{confirm}" 
            class="bg-red-500 text-white py-1 px-2 rounded hover:bg-red-700 {disableConfirm || isReadOnly() ? 'opacity-50 cursor-not-allowed' : ''}" 
            disabled={disableConfirm || isReadOnly()}
            title={disableMessage || ''}
          >Confirm</button>
        </div>
      </div>
    </div>
  {/if}